(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sector-position', {
            parent: 'entity',
            url: '/sector-position?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sectorPosition.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector-position/sector-positions.html',
                    controller: 'SectorPositionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectorPosition');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sector-position-detail', {
            parent: 'entity',
            url: '/sector-position/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.sectorPosition.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector-position/sector-position-detail.html',
                    controller: 'SectorPositionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sectorPosition');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SectorPosition', function($stateParams, SectorPosition) {
                    return SectorPosition.get({id : $stateParams.id});
                }]
            }
        })
        .state('sector-position.new', {
            parent: 'sector-position',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-position/sector-position-dialog.html',
                    controller: 'SectorPositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sector-position', null, { reload: true });
                }, function() {
                    $state.go('sector-position');
                });
            }]
        })
        .state('sector-position.edit', {
            parent: 'sector-position',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-position/sector-position-dialog.html',
                    controller: 'SectorPositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SectorPosition', function(SectorPosition) {
                            return SectorPosition.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector-position', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sector-position.delete', {
            parent: 'sector-position',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector-position/sector-position-delete-dialog.html',
                    controller: 'SectorPositionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SectorPosition', function(SectorPosition) {
                            return SectorPosition.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector-position', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
